import * as z from "zod";

export const getInternationalReadiness = {
  name: "getInternationalReadiness" as const,
  input: z.null(),
  output: z.object({
    /** Customs fields the return destinations require; empty when the store has no return destinations. */
    destinationRequiredFields: z.array(
      z.enum(["hsCode", "originCountry", "manufacturerId"]),
    ),
    /** True when a Redo market includes an EU country, which requires EU product identifiers. */
    euProductIdentifiersRequired: z.boolean(),
    /** Customs fields the merchant must provide after Redo-assisted coverage. */
    requiredFields: z.array(
      z.enum([
        "hsCode",
        "customsDescription",
        "originCountry",
        "manufacturerId",
      ]),
    ),
    /** Per-type counts currently tagged delayed-in-customs (non-terminal statuses). */
    stuckCounts: z.object({
      return: z.number(),
      claim: z.number(),
      warranty: z.number(),
    }),
    catalog: z.object({
      total: z.number(),
      valid: z.number(),
      readinessPercent: z.number(),
      missingHsCode: z.number(),
      missingCustomsDescription: z.number(),
      missingOriginCountry: z.number(),
      missingManufacturerId: z.number(),
      missingMerchantProductId: z.number(),
      missingManufacturerProductId: z.number(),
      missingStandardizedProductId: z.number(),
      /** True when only the newest products were counted, so the counts are lower bounds. */
      capped: z.boolean(),
    }),
  }),
};
